module.exports = __webpack_public_path__ + "assets/img/btn-view-all-fbc63287.png";